import * as React from 'react';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

const CustomListItemSecondaryAction = (props) => {
    return <ListItemSecondaryAction {...props} />;
};

export { CustomListItemSecondaryAction as ListItemSecondaryAction };
